import { Children, createContext, useContext, useEffect } from "react";
import { useGameStateContext } from "./GameStateContextProvider";

const AnimationSeqContext = createContext({});

var registeredComponents = [];
export const AnimationSeqContextProvider = ({ win, children , state}) => {
    const gameState = useGameStateContext();

    const registerComponent = (name, priority, callback) => {
        if (!registeredComponents.find((e) => e.name === name)) {
            registeredComponents.push({ "name": name, "priority": priority, "callback": callback });
            registeredComponents.sort((a, b) => a.priority > b.priority)
        }
    }

    useEffect(() => {

        const doWinAnimation = async () => {
            for (const lineName in win.accountedWins) {
                await Promise.all(registeredComponents.map(async (comp) => {
                    await comp.callback({ type: 'lineWin', 'win': win.accountedWins[lineName], 'line': lineName });
                }))
                //for(const registeredComponent of registeredComponents)
                //   await registeredComponent.callback({type:"lineWin", 'reelSymbols': win.accountedWins[lineName].positions});
            }
            await new Promise(r => setTimeout(r, 1000));
            gameState.onAnimationFinished();
        }

        const doMatchAnimation = async (type) => {
            
            await new Promise(r => setTimeout(r, 3500));
            await Promise.all(registeredComponents.map(async (comp) => {
                await comp.callback({ type: 'jackpotMatches', 'matches':  state.jackpotSymMatches});
            }))
            await new Promise(r => setTimeout(r, 1000));
            gameState.onAnimationFinished();
        }

        const doDelay = async (ms) => {
            await new Promise(r => setTimeout(r, ms));
            gameState.onAnimationFinished();
        }

        
        const doResetAnimation = async (ms) => {
            await Promise.all(registeredComponents.map(async (comp) => {
                await comp.callback({ type: 'reset'});
            }))
        } 
        if (gameState.state === 'winAnimation1' || gameState.state === 'winAnimation2') {
            if (win && Object.keys(win).length > 0)
                doWinAnimation();
            else if (gameState.state === 'winAnimation1')
                doMatchAnimation();
            else
                doDelay(3000);
        }if (gameState.state === 'spin2'){
            doResetAnimation();
        }
    }, [gameState.state])

    const providerValue = {
        register: registerComponent
    }
    return (
        <AnimationSeqContext.Provider value={providerValue}> {children} </AnimationSeqContext.Provider>
    )
}

export const useAnimationSeqContext = () => useContext(AnimationSeqContext)